import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import api from "../lib/api";

/**
 * SiteHead injects site-wide head tags that depend on backend settings:
 *  - Google Search Console verification meta tag
 *  - Google Analytics 4 (GA4) script
 * Mounted once near the root of every public page (skipped under /admin).
 */
export default function SiteHead() {
  const [s, setS] = useState(null);

  useEffect(() => {
    // Don't surface analytics inside the admin area
    if (window.location.pathname.startsWith("/admin")) return;
    api.get("/settings").then((r) => setS(r.data)).catch(() => {});
  }, []);

  if (!s) return null;
  const ga = s.google_analytics_id;
  const verify = s.google_verification;

  return (
    <Helmet>
      {verify && <meta name="google-site-verification" content={verify} />}
      {ga && (
        <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga}`} />
      )}
      {ga && (
        <script>{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${ga}');
        `}</script>
      )}
    </Helmet>
  );
}
